import { Components, Theme } from '@mui/material'
import { primaryContainedButtonStyle, secondaryContainedButtonStyle } from './MuiButton'

// Attempt to identify the common "last button is icon button" pattern
const lastButtonWithIconSelector = '& .MuiButtonGroup-lastButton:has(> svg:first-child:last-child)'

export const MuiButtonGroup: Components<Omit<Theme, 'components'>>['MuiButtonGroup'] = {
  defaultProps: {
    disableRipple: true,
    disableElevation: true,
  },
  styleOverrides: {
    middleButton: () => ({
      border: 'none',
    }),
  },
  variants: [
    // Colour
    {
      props: { color: 'primary', variant: 'contained' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.bg.brand.default,
        '& .MuiButton-root': primaryContainedButtonStyle(theme),
        '& .MuiButtonGroup-firstButton, & .MuiButtonGroup-middleButton': {
          borderRightWidth: theme.strokeWidth.default,
          borderRightColor: theme.palette.border.transparent,
        },
      }),
    },
    {
      props: (props) => (props.color === 'secondary' && props.variant === 'contained') || props.variant === 'outlined',
      style: ({ theme }) => ({
        '& .MuiButton-root': secondaryContainedButtonStyle(theme),
        '& .MuiButtonGroup-firstButton, & .MuiButtonGroup-middleButton': {
          borderRightWidth: theme.strokeWidth.default,
          borderRightColor: theme.palette.border.subtle,
        },
      }),
    },
    // Size
    {
      props: { size: 'large' },
      style: ({ theme }) => ({
        borderRadius: theme.shape['radius-lg'],
        [lastButtonWithIconSelector]: {
          padding: theme.spacing(2.5),
        },
      }),
    },
    {
      props: { size: 'medium' },
      style: ({ theme }) => ({
        borderRadius: theme.shape['radius-lg'],
        [lastButtonWithIconSelector]: {
          padding: theme.spacing(2),
        },
      }),
    },
    {
      props: { size: 'small' },
      style: ({ theme }) => ({
        borderRadius: theme.shape['radius-md'],
        [lastButtonWithIconSelector]: {
          padding: theme.spacing(1),
          minWidth: 'unset',
        },
      }),
    },
  ],
}
